<template>
  <div class="order-management">
    <van-nav-bar title="订单管理" fixed placeholder right-text="筛选" left-arrow @click-left="onClickLeft"
      @click-right="onClickRight" ref="navBar" />
    <van-tabs type="card" v-model="activeName" swipeable sticky :offset-top="navBarHeight">
      <van-tab :title="itemTab.title" :name="itemTab.name" v-for="(itemTab,index) in tabs" :key="index">
        <template #title v-if="itemTab.name=='a'">
          <i class="dot" v-show="num">{{num}}</i>未处理
        </template>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" error-text="请求失败" @load="onLoad"
          offset="50">
          <div class="untreated" v-for="item in dataList" :key="item.id">
            <div class="order">
              <p>订单号：{{item.order_num}}</p>
              <p>类型：{{item.order_type}}>{{item.type}}</p>
              <p>价格：{{item.price||'面议'}}</p>
              <p v-if="activeName==='b'">对接人：{{item.user_name}}</p>
              <p>订单状态：{{item.status==0?'正常':'失败'}}</p>
              <p>下单时间：{{item.create_time}}</p>
              <p>修改时间：{{item.update_time}}</p>
            </div>
            <div class="look">
              <span @click="checkTheDetails(item.id)">查看</span>
              <span @click="Modify(item.id)">修改</span>
            </div>
            <div class="box0" v-show="itemTab.name=='a'">
              <span class="state">新</span>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
    <!-- 查看订单 -->
    <van-popup v-model="show" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <h5 class="popup-title">详细信息</h5>
      <div class="information">
        <div class="popup-header">订单信息</div>
        <p>订单号：{{orderDetail.order_num}}</p>
        <p>订单时间：{{orderDetail.create_time}}</p>
        <p>订单进度：{{orderDetail.order_jd}}</p>
        <p>订单类型：{{orderDetail.order_type}}</p>
        <p>商品名称：{{orderDetail.goods_title}}</p>
        <p>商品状态：{{orderDetail.order_msg}}</p>
        <p>总价格：{{orderDetail.price}}</p>
        <p>已付费用：{{orderDetail.yf_price}}</p>
        <p>前期款：{{orderDetail.pq_price}}</p>
        <p>尾款：{{orderDetail.wk_price}}</p>
        <p>合同：<span @click="()=>{shows=true}" style="color:#2DADB1;">点击查看</span></p>
        <div class="popup-header m57">
          用户信息
          <!-- <span class="looknew">
              查看详情 &nbsp;
              <van-icon name="arrow" />
            </span>-->
        </div>
        <p>姓名：{{userdetail.name || ''}}</p>
        <p>手机号：{{userdetail.phone}}</p>
        <p>邮箱：{{userdetail.mailbox}}</p>
        <p>性别：{{userdetail.sex}}</p>
        <p>公司名称：{{userdetail.gsmc}}</p>
        <p>职务：{{userdetail.grzw}}</p>
        <p>座机：{{userdetail.tel}}</p>
        <p>省：{{userdetail.province}}</p>
        <div class="docking">
          <div class="foot">
            <a :href="'tel:'+ userdetail.phone" class="tel">拨打电话</a>
            <div @click="ConfirmTheDocking(orderDetail.id)" v-show="activeName === 'a'">确认对接</div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 查看合同 -->
    <van-image-preview v-model="shows" :images="[images]" closeable :showIndex="false" />
    <!-- 修改订单 -->
    <van-popup v-model="ordershow" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <h5 class="popup-title">订单修改</h5>
      <div class="orderinformation">
        <p>订单号：{{orderDetail.order_num}}</p>
        <p>订单时间：{{orderDetail.create_time}}</p>
        <p>商品名称：{{orderDetail.goods_title}}</p>
        <p>商品状态：{{orderDetail.order_msg}}</p>
        <van-form @submit="ModifyOrder()" label-width='1.5rem' label-align='right'>
          <van-field v-model="orderInfoModify.order_jd" label="订单进度" placeholder="订单进度" />
          <van-field v-model="orderInfoModify.yf_price" label="已付费用" placeholder="0.00" />
          <van-field v-model="orderInfoModify.pq_price" label="前期款" placeholder="0.00" />
          <van-field v-model="orderInfoModify.wk_price" label="尾款" placeholder="0.00" />
          <van-field name="uploader" label="合同" class="back-tran">
            <template #input>
              <input type="text" v-model="inpfile" placeholder="未选择任何文件" readonly />
              <van-uploader :before-read="beforeRead">上传文件</van-uploader>
            </template>
          </van-field>
          <van-button :loading="submitLoading" :disabled="submitLoading" type="primary" block color="#2DADB1"
            native-type="submit">提交</van-button>
        </van-form>
      </div>
    </van-popup>
    <!-- <drop-list :config="configData" ref="droplist"></drop-list> -->
    <div class="screening" v-show="screeningshow">
      <ul>
        <li v-for="item in screeningList" :key="item.id" :class="{'ccc':item.id===category}"
          @click="screening(item.id)">
          {{item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  OrderList,
  UnprocessedOrder,
  ViewOrderDetails,
  docking,
  orderModify
} from '@/api/order.js'
import { mapState } from 'vuex'
import { updateUserPhoto } from '@/api/user.js'
import delItem from '@/utils/delitem.js'
// import DropList from 'vue-droplist'
export default {
  name: 'ordermanagement',
  props: {},
  data () {
    return {
      tabs: [
        { title: '未处理', name: 'a' },
        { title: '已处理', name: 'b' }
      ],
      activeName: 'a',
      dataList: [], // 未处理/已处理订单列表
      num: '', // 未处理订单数量
      screeningshow: false, // 筛选内容选择框
      show: false, // 订单信息展示框
      shows: false, // 查看合同展示框
      ordershow: false, // 订单修改框
      orderDetail: {}, // 订单信息
      userdetail: {}, // 用户信息
      images: '', // 查看合同图片路径
      inpfile: '', // 上传合同文件
      screeningList: [
        { id: 0, name: '全部' },
        { id: 1, name: '质押融资' },
        { id: 2, name: '创新服务' },
        { id: 3, name: '知识产权' },
        { id: 4, name: '知产交易' }
      ],
      category: '', // 筛选的id
      isSX: false, // 判断要获取筛选数据还是所有数据
      // 修改订单的内容
      orderInfoModify: {
        id: '',
        contract: '',
        wk_price: '',
        pq_price: '',
        yf_price: '',
        order_jd: ''
      },
      page: 0,
      loading: false,
      finished: false,
      isData: false, // 是否停止加载 true：停止加载，false：继续加载
      navBarHeight: 44, // 头部高度
      source: null,
      submitLoading: false
    }
  },
  computed: {
    ...mapState(['user'])
  },
  watch: {
    activeName (newVal, oldVal) {
      if (this.source) {
        this.source.cancel({ type: 409, msg: '操作频繁' })
      }
      this.onLoad(true)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.navBarHeight = this.$refs.navBar.$el.offsetHeight
    })
  },
  methods: {
    onClickLeft () {
      this.$router.back()
    },
    onClickRight () {
      this.screeningshow = !this.screeningshow
    },
    // 列表加载
    async onLoad (type) {
      if (type) {
        this.unprocessedList = []
        this.ProcessingList = []
        this.dataList = []
        this.page = 0
        this.loading = true
        this.finished = false
        this.isData = false
      }
      this.page += 1
      if (!this.isSX) {
        if (this.activeName === 'a') {
          await this.getUnprocessedOrder(this.page)
        } else {
          await this.getProcessingList(this.page)
        }
      } else {
        await this.getShaiXuan()
      }
      await this.$delay(800)
      this.loading = false
      if (this.isData) {
        this.loading = false
        this.finished = true
      } else {
        this.finished = false
      }
    },
    // 未处理订单列表
    async getUnprocessedOrder (page, category) {
      this.source = this.$Axios.CancelToken.source()
      try {
        const data = await UnprocessedOrder(page, category, this.source.token)
        if (data.error_code === 1) {
          this.dataList = [...this.dataList, ...data.data.orderInfo]
          this.num = data.data.nums
          if (this.dataList.length >= data.data.nums) {
            this.isData = true
          } else {
            this.isData = false
          }
        } else {
          this.$toast('获取列表失败')
        }
      } catch (error) {
        this.isData = true
        if (error.message.type === 409) {
          this.$toast(error.message.msg)
        }
      }
    },
    // 已处理订单列表
    async getProcessingList (page, category) {
      this.source = this.$Axios.CancelToken.source()
      try {
        const data = await OrderList(page, category, this.source.token)
        if (data.error_code === 1) {
          this.dataList = [...this.dataList, ...data.data.orderInfo]
          if (this.dataList.length >= data.data.nums) {
            this.isData = true
          } else {
            this.isData = false
          }
        } else {
          this.$toast('获取列表失败')
        }
      } catch (error) {
        this.isData = true
        if (error.message.type === 409) {
          this.$toast(error.message.msg)
        }
      }
    },
    // 筛选功能
    async screening (id) {
      this.category = id
      this.screeningshow = !this.screeningshow
      this.isSX = true
      this.onLoad(true)
    },
    // 筛选事件
    async getShaiXuan () {
      if (this.activeName === 'a') {
        this.getUnprocessedOrder(this.page, this.category)
      } else if (this.activeName === 'b') {
        this.getProcessingList(this.page, this.category)
      }
    },
    // 订单查看详情
    async checkTheDetails (id) {
      try {
        const data = await ViewOrderDetails(id)
        if (data.error_code === 1) {
          this.orderDetail = data.data.order
          this.userdetail = data.data.userInfo || {}
          this.images = this.$base + this.orderDetail.contract
          this.orderDetail.goods_title = this.orderDetail.goods_title ? this.orderDetail.goods_title : this.orderDetail.type
          if (this.orderDetail.type === '专利资产包' || this.orderDetail.type === '商标资产包') {
            switch (this.orderDetail.order_msg) {
              case 1:
                this.orderDetail.order_msg = '该资产包已删除'
                break
              case 2:
                this.orderDetail.order_msg = '该资产包内容有变动'
                break
              default:
                this.orderDetail.order_msg = '正常'
                break
            }
          } else {
            switch (this.orderDetail.order_msg) {
              case 1:
                this.orderDetail.order_msg = '该商品已删除'
                break
              case 2:
                this.orderDetail.order_msg = '该商品内容有变动'
                break
              default:
                this.orderDetail.order_msg = '正常'
                break
            }
          }
          if (!this.ordershow) {
            this.show = true
          }
        }
      } catch (error) {
        return error.message
      }
    },
    // 上传合同
    async beforeRead (file) {
      this.submitLoading = true
      this.inpfile = file.name
      const data = await updateUserPhoto('files', file)
      if (data.error_code === 1) {
        this.orderInfoModify.contract = data.data
      } else {
        this.$toast('操作失败')
      }
      this.submitLoading = false
    },
    // 修改操作框
    async Modify (id) {
      this.ordershow = true
      await this.checkTheDetails(id) // 获取订单详情
      for (const key in this.orderInfoModify) {
        this.orderInfoModify[key] = this.orderDetail[key]
      }
      this.inpfile = this.orderDetail.contract
    },
    // 修改订单
    async ModifyOrder () {
      if (!this.orderInfoModify.contract || !this.orderInfoModify.wk_price || !this.orderInfoModify.pq_price || !this.orderInfoModify.yf_price || !this.orderInfoModify.order_jd) {
        return this.$toast('请完善信息后提交')
      }
      try {
        const data = await orderModify(this.orderInfoModify)
        if (data.error_code === 1) {
          this.ordershow = false
          this.$toast('修改成功')
        } else {
          this.$toast('修改失败')
        }
      } catch (error) {
        return error.message
      }
    },

    // 订单对接
    async ConfirmTheDocking (id) {
      try {
        const data = await docking(this.orderDetail.id)
        if (data.error_code === 1) {
          this.$toast('对接成功')
          this.dataList = delItem(this.dataList, id)
          this.show = false
          this.num -= 1
          if (this.dataList.length === 0) {
            setTimeout(() => {
              this.activeName = 'b'
            }, 1000)
          }
        } else {
          this.$toast('操作失败')
        }
      } catch (error) {
        return error.message
      }
    }
  }
}
</script>

<style scoped lang="less">
.order-management {
  height: 100%;
  background-color: #fbfbfb;
  /deep/ .van-nav-bar {
    line-height: 88px;
    font-size: 30px;
    font-weight: 400;
    color: rgba(21, 21, 21, 1);
  }
  /deep/ .van-popup--bottom {
    width: 95%;
    left: 18px;
    background-color: #f8f8f8;
  }
  /deep/ .van-nav-bar__text {
    color: #666666 !important;
  }
  /deep/ .van-tabs__nav--card {
    margin: 0 24px;
    border: none;
  }
  /deep/ [class*="van-hairline"]::after {
    border: none;
  }
  /deep/ .van-tabs__nav--card .van-tab {
    line-height: 80px;
    border: none;
    color: #6c6c6c;
    font-size: 28px;
    background-color: #f3f1f1;
  }
  /deep/ .van-tabs--card > .van-tabs__wrap {
    height: 80px;
    line-height: 80px;
  }
  /deep/ .van-tabs--card .van-tabs__wrap,
  /deep/ .van-tabs--card .van-tabs__wrap .van-tabs__nav {
    background-color: #fbfbfb;
  }
  /deep/ .van-tabs__nav--card {
    height: 100px !important;
    line-height: 100px;
    border: none;
    padding-bottom: 20px;
  }
  /deep/ .van-tabs__nav--card .van-tab.van-tab--active {
    background: rgba(45, 173, 177, 1) !important;
    color: #fff;
  }
  .untreated {
    display: flex;
    justify-content: space-between;
    width: 702px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(10, 10, 10, 0.3);
    box-sizing: border-box;
    margin: 6px auto 24px;
    p {
      font-size: 28px;
      font-weight: 400;
      color: #151515;
      margin-bottom: 26px;
    }
    p:last-child {
      margin-bottom: 0;
    }
    .order {
      width: 78%;
      padding: 40px 10px 40px 38px;
    }
    span {
      font-size: 28px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .look {
      flex: 1;
      background: rgba(45, 173, 177, 1);
      text-align: center;
      padding: 20px;
      box-sizing: border-box;
      line-height: 200px;
    }
    .box0 {
      width: 0px;
      height: 0px;
      border-top: 47px solid #e83c34;
      border-right: 47px solid transparent;
      position: absolute;
    }
    .state {
      display: block;
      width: max-content;
      color: #fff;
      position: absolute;
      font-size: 18px;
      bottom: 20px;
    }
  }
  .information {
    padding: 82px 60px 33px 60px;
    color: #151515;
    .looknew {
      color: #666666;
      text-align: center;
      padding-left: 50%;
      .van-icon-arrow {
        font-size: 20px;
      }
    }

    .docking {
      margin-top: 42px;
      .tel {
        display: block;
        width: 240px;
        height: 80px;
        line-height: 80px;
        background: rgba(20, 189, 123, 1);
        font-size: 34px;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        width: 100%;
      }
      .foot {
        div {
          width: 100%;
          height: 80px;
          line-height: 80px;
          background: #2dadb1;
          font-size: 34px;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          margin-left: 44px;
        }
        display: flex;
        padding: 0 40px;
        margin: 0 auto;
        margin-top: 65px;
      }
      p {
        margin-bottom: 24px;
        margin-top: 0;
      }
    }
    p {
      font-size: 28px;
      font-weight: 400;
      color: rgba(21, 21, 21, 1);
      margin-top: 33px;
    }
  }

  .orderinformation {
    padding: 82px 60px 33px 60px;
    p {
      margin-bottom: 24px;
      margin-top: 0;
      font-size: 28px;
      font-weight: 400;
      color: #666666;
    }
    /deep/ .van-cell {
      padding: 15px 0;
      .van-uploader__input-wrapper {
        color: #2dadb1;
      }
    }
    /deep/ .van-button--block {
      margin: 60px auto;
    }
  }
  .dot {
    min-width: 36px;
    height: 36px;
    width: auto;
    line-height: initial;
    background: rgba(232, 60, 52, 1);
    border-radius: 50%;
    text-align: center;
    color: #fff;
    font-size: 24px;
    font-weight: 400;
    display: inline-block;
    background-color: #e83c34;
    position: absolute;
    right: 80px;
    top: 8px;
  }
  .mei {
    margin: 50% auto;
    text-align: center;
    font-size: 30px;
  }
  .screening {
    position: fixed;
    z-index: 99;
    top: 70px;
    right: 24px;
    width: 171px;
    background-color: #fff;
    text-align: center;
    box-shadow: 0px 5px 13px 0px rgba(15, 15, 15, 0.28);
    li {
      font-size: 28px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 80px;
      border-bottom: 1px solid #dedede;
    }
    .ccc {
      background-color: #f7f7f7;
    }
  }
  /deep/ .van-field__control::-webkit-input-placeholder {
    font-size: 28px;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
  }
  /*  Mozilla Firefox 4-18使用伪类 */
  /deep/ .van-field__control:-moz-placeholder {
    font-size: 28px;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
  }
  /* Mozilla Firefox 19+ 使用伪元素  */
  /deep/ .van-field__control::-moz-placeholder {
    font-size: 28px;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
  }
  /* IE10使用伪类 */
  /deep/ .van-field__control:-ms-input-placeholder {
    font-size: 28px;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
  }
}
</style>
